var map = {
	"./academy.svg": 7955,
	"./alibaba.svg": 4889,
	"./avatar.svg": 256,
	"./aws.svg": 5950,
	"./blog.svg": 847,
	"./bootcamp.svg": 2144,
	"./bulb.svg": 554,
	"./cloud.svg": 1326,
	"./customer.svg": 7511,
	"./customer2.svg": 1687,
	"./globe.svg": 5938,
	"./google.svg": 3486,
	"./jobseek.svg": 9808,
	"./microsoft.svg": 913,
	"./news.svg": 8566,
	"./partners.svg": 9566,
	"./podcasts.svg": 5236,
	"./suitecase.svg": 965,
	"./teamskill.svg": 6663,
	"./upskilling.svg": 9125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;